const sizes = {
  contentMaxWidth: "1000px",
  headerMaxWidth: "1400px",
  contentPadding: "48px",
  contentPaddingSmall: "20px",
  borderRadius: "9px",
};
export default sizes;
